import { render } from "./SearchResultProductList.vue?vue&type=template&id=2930f557&scoped=true"
import script from "./SearchResultProductList.vue?vue&type=script&lang=js"
export * from "./SearchResultProductList.vue?vue&type=script&lang=js"

import "./SearchResultProductList.vue?vue&type=style&index=0&id=2930f557&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2930f557"]])

export default __exports__